import i18next from 'i18next'
import { I18nextProvider } from 'react-i18next'

export const withI18next = (WrappedComponent: any) => {
  return function (props: any) {
    return (
      <I18nextProvider i18n={i18next}>
        <WrappedComponent {...props} />
      </I18nextProvider>
    )
  }
}
